var nsModuleExport = function(root,name,prototype)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			module.exports[name] = prototype;
		}
		else if (typeof define === "function" && define.amd)
		{
			define(name,[], function () {return prototype;});
		}
		else if(typeof exports === 'object')
		{
			exports[name] = prototype;
		}
		else
		{
			root[name] = prototype;
		}
	};var nsIsWeb = function(root)
	{
		if(typeof exports === 'object' && typeof module === 'object')
		{
			return false;
		}
		else if (typeof define === "function" && define.amd)
		{
			return false;
		}
		else if(typeof exports === 'object')
		{
			return false;
		}
		else
		{
			return true;
		}
	};if(!nsIsWeb())
		{
var nsutilRef = require('./nsUtil.min.js');
var NSUtil = nsutilRef.NSUtil;

		}
var NSSvg = (function()
{
	function NSSvg()
	{
		this.namespace = "http://www.w3.org/2000/svg";
		this.xmlns = "http://www.w3.org/2000/xmlns/";
		this.xlink = "http://www.w3.org/1999/xlink";
		this.version = "1.2";
		this.__mainSVGID = "nsMainSVG";
		this.__defaultViewPort = "0 0 100 100";
		
		this.util = new NSUtil();
	};
	
	NSSvg.prototype.getMainSVG = function()
	{
		var mainSVGElement = document.getElementById(this.__mainSVGID);
		if(!mainSVGElement)
		{
			var body = document.body || document.getElementsByTagName('body')[0];
			mainSVGElement = this.addSVG(body,this.__mainSVGID,null,0,0);
			mainSVGElement.setAttribute("display","none");
		}
		return mainSVGElement;
	};
	
	NSSvg.prototype.addSVG = function(parent,id,className,width,height,fromX,fromY,toX,toY,disableEvents) 
	{
		var svg = this.createSVG(id,className,width,height,fromX,fromY,toX,toY,disableEvents);
		if(parent)
		{
			parent.appendChild(svg);
		}
		return svg;
	};
	
	NSSvg.prototype.symbolExists = function(id)
	{
		var svg = this.getMainSVG();
		var retValue = (svg.getElementById(id)) ? true : false;
		return retValue;
	};
	
	NSSvg.prototype.addSymbol = function(id,viewBox,preserveAspectRatio)
	{
		var svg = this.getMainSVG();
		var symbol = this.createSymbol(id,viewBox,preserveAspectRatio);
		svg.appendChild(symbol);
		return symbol;
	};
	
	NSSvg.prototype.addUse = function(parent,id,className,href,width,height,x,y,transform)
	{
		var use = this.createUse(id,className,href,width,height,x,y,transform);
		if(parent)
		{
			parent.appendChild(use);
			//parent.innerHTML = use.outerHTML;
		}
		return use;
	};
	
	NSSvg.prototype.addPath = function(id,pathString,viewPort,fill) 
	{
		var path = this.createPath(id + "path",pathString,null,fill);
		this.addElementInSymbol(id,viewPort,path);
	};
	
	NSSvg.prototype.addCircle = function(id,centerX,centerY,radius,className,viewPort) 
	{
		var circle = this.createCircle(id,centerX,centerY,radius,className);
		this.addElementInSymbol(id,viewPort,circle);
	};
	
	NSSvg.prototype.addPolygon = function(id,points,className,viewPort) 
	{
		 var polygon = this.createPolygon(id,points,className);
		 this.addElementInSymbol(id,viewPort,polygon);
	};
	
	NSSvg.prototype.addLine = function(parent,id,xFrom,yFrom,xTo,yTo,className,viewPort) 
	{
		 var line = this.createLine(id,xFrom,yFrom,xTo,yTo,className);
		 this.addElementInSymbol(id,viewPort,line);
	};
	
	NSSvg.prototype.createSVG = function(id,className,width,height,fromX,fromY,toX,toY,disableEvents)
	{
		var svg = document.createElementNS(this.namespace, "svg");
		svg.setAttribute("xmlns", this.namespace);
		svg.setAttributeNS(this.xmlns, "xmlns:xlink", this.xlink);
		svg.setAttribute("version", this.version);
		if(id)
		{
			svg.setAttribute("id",id);
		}
		if(className)
		{
			 this.util.addStyleClass(svg,className);
		}
		if(this.util.isNumber(width))
		{
			svg.setAttribute("width", width);
		}
		if(this.util.isNumber(height))
		{
			svg.setAttribute("height", height);
		}
		if(this.util.isNumber(fromX) && this.util.isNumber(fromY) && this.util.isNumber(toX) && this.util.isNumber(toY) && toX > 0 && toY > 0)
		{
			var viewBox = fromX + " " + fromY + " " + toX + " " + toY;
			svg.setAttribute("viewBox", viewBox);
		}
		if(this.util.isUndefined(disableEvents) || disableEvents === null)
		{
			disableEvents = false;
		}
		if(disableEvents)
		{
			svg.style.pointerEvents = "none";
		}
		return svg;
	};
	
	NSSvg.prototype.createSymbol = function(id,viewBox,preserveAspectRatio) 
	{
		 var symbol = document.createElementNS(this.namespace,"symbol");
		 if(id)
		 {
			 symbol.setAttributeNS(null,"id",id);
		 }
		 if(viewBox)
		 {
			 symbol.setAttribute("viewBox", viewBox);
		 }
		 if(preserveAspectRatio)
		 {
			 symbol.setAttribute("preserveAspectRatio", preserveAspectRatio);
		 }
		 return symbol;
	};
	
	NSSvg.prototype.createUse = function(id,className,href,width,height,x,y,transform)
	{
		var use = document.createElementNS(this.namespace, "use");
		if(id)
		{
			use.setAttributeNS(null,"id",id);
		}
		if(className)
		{
			 this.util.addStyleClass(use,className);
		}
		if(href)
		{
			use.setAttributeNS(this.xlink,"href",href);
		}
		if(this.util.isNumber(width))
		{
			use.setAttribute("width", width);
		}
		if(this.util.isNumber(height))
		{
			use.setAttribute("height", height);
		}
		if(this.util.isNumber(x))
		{
			use.setAttribute("x", x);
		}
		if(this.util.isNumber(y))
		{
			use.setAttribute("y", y);
		}
		if(transform)
		{
			use.setAttribute("transform",transform);
		}
		return use;
	};
	
	NSSvg.prototype.createLine = function(id,xFrom,yFrom,xTo,yTo,className) 
	{
		 var line = document.createElementNS(this.namespace,"line");
		 if(id)
		 {
			 line.setAttributeNS(null,"id",id);
		 }
		 line.setAttributeNS(null,"x1",xFrom);
		 line.setAttributeNS(null,"y1",yFrom);
		 line.setAttributeNS(null,"x2",xTo);
		 line.setAttributeNS(null,"y2",yTo);
		 if(className)
		 {
			 this.util.addStyleClass(line,className);
		 }
		 return line;
	};
	
	NSSvg.prototype.createCircle = function(id,centerX,centerY,radius,className) 
	{
		 var circle = document.createElementNS(this.namespace,"circle");
		 if(id)
		 {
			 circle.setAttributeNS(null,"id",id);
		 }
		 circle.setAttributeNS(null,"cx",centerX);
		 circle.setAttributeNS(null,"cy",centerY);
		 circle.setAttributeNS(null,"r",radius);
		 if(className)
		 {
			 this.util.addStyleClass(circle,className);
		 }
		 return circle;
	};
	
	NSSvg.prototype.createRect = function(id,x,y,width,height,className) 
	{
		 var rect = document.createElementNS(this.namespace,"rect");
		 if(id)
		 {
			 rect.setAttributeNS(null,"id",id);
		 }
		 if(!this.util.isUndefinedOrNull(x))
		 {
			 rect.setAttributeNS(null,"x", x);
		 }
		 if(!this.util.isUndefinedOrNull(y))
		 {
			 rect.setAttributeNS(null,"y", y);
		 }
		 if(!this.util.isUndefinedOrNull(width))
		 {
			 rect.setAttributeNS(null,"width",width);
		 }
		 if(!this.util.isUndefinedOrNull(height))
		 {
			 rect.setAttributeNS(null,"height", height);
		 }
		 if(className)
		 {
			 this.util.addStyleClass(rect,className);
		 }
		 return rect;
	};
	
	NSSvg.prototype.createPolygon = function(id,points,className) 
	{
		 var polygon = document.createElementNS(this.namespace,"polygon");
		 if(id)
		 {
			 polygon.setAttributeNS(null,"id",id);
		 }
		 polygon.setAttribute("points",points);
		 if(className)
		 {
			 this.util.addStyleClass(polygon,className);
		 }
		 return polygon;
	};
	
	NSSvg.prototype.createPath = function(id,pathString,className,fill) 
	{
		 var path = document.createElementNS (this.namespace, "path");
		 if(id)
		 {
			 path.setAttribute("id", id);
		 }
		 path.setAttribute("d", pathString);
		 if(className)
		 {
			 this.util.addStyleClass(path,className);
		 }
		 if(fill)
		 {
			 path.setAttribute("fill", fill);
		 }
		 return path;
	};
	
	NSSvg.prototype.createGroup = function(id) 
	{
		 var group = document.createElementNS (this.namespace, "g");
		 if(id)
		 {
			 group.setAttribute("id", id);
		 }
		 return group;
	};
	
	NSSvg.prototype.changeUseHref = function(use,href) 
	{
		 use = this.util.getElement(use);
		 if(use)
		 {
			use.setAttributeNS(this.xlink,"href",href);
			return true;
		 }
		 return false;
	};
	
	NSSvg.prototype.changePathValue = function (objPath,pathString) 
	{
		 var path = this.util.getElement(objPath);
		 if(path)
		 {
			 path.setAttribute("d", pathString);
			 return true;
		 }
		 return false;
	};
	
	NSSvg.prototype.getPathValue = function (objPath) 
	{
		 var path = this.util.getElement(objPath);
		 if(path)
		 {
			 return path.getAttribute("d");
		 }
		 return null;
	};
	
	NSSvg.prototype.addElementInSymbol = function(id,viewPort,element)
	{
		if(!this.symbolExists(id) && element)
		{
			if(!viewPort)
			{
				viewPort = this.__defaultViewPort;
			}
			var symbol = this.addSymbol(id,viewPort);
			symbol.appendChild(element);
		}
	};
	
	return NSSvg;
})();
nsModuleExport(this,"NSSvg",NSSvg);
	
var NSSvgShapes = (function()
{	
	function NSSvgShapes()
	{
		this.__EXPORT_ICON_ID = "nsSvgExport";
		this.__MINIMIZE_ICON_ID = "nsSvgMinimize";
		this.__MAXIMIZE_ICON_ID = "nsSvgMaximize";
		this.__EXPAND_ICON_ID = "nsSvgExpand";
		this.__COLLAPSE_ICON_ID = "nsSvgCollapse";
		this.__FULLSCREEN_ICON_ID = "nsSvgFullScreen";
		this.__RESTORE_ICON_ID = "nsSvgRestore";
		this.__FILTER_ICON_ID = "nsSvgFilter";
		this.__SEARCH_ICON_ID = "nsSvgSearch";
		this.__CLOSE_ICON_ID = "nsSvgClose";
		this.__TREE_ICON_ID = "nsSvgTree";
		this.__EXPORT_ICON_ID = "nsSvgExport";
		this.__MOVE_ICON_ID = "nsSvgMove";
		this.__HISTORY_ICON_ID = "nsSvgHistory";
		this.__PENDING_ICON_ID = "nsSvgPending";
		this.__SUPERVISOR_ICON_ID = "nsSvgSupervisor";
		this.__ENTITY_ICON_ID = "nsSvgEntity";
		this.__DIVISION_ICON_ID = "nsSvgDivision";
		this.__GROUP_ICON_ID = "nsSvgGroup";
		this.__LEFT_ICON_ID = "nsSvgLeft";
		this.__RIGHT_ICON_ID = "nsSvgRight";
		this.__HIERARCHY_ICON_ID = "nsSvgHierarchy";
		this.__EQUAL_ICON_ID = "nsSvgEqual";
		this.__GREAT_ICON_ID = "nsSvgGreat";
		this.__GREATEQUAL_ICON_ID = "nsSvgGreatEqual";
		this.__LESS_ICON_ID = "nsSvgLess";
		this.__LESSEQUAL_ICON_ID = "nsSvgLessEqual";
		this.__FOCUSVIEW_ICON_ID = "nsSvgFocusView";
		this.__HOLISTICVIEW_ICON_ID = "nsSvgHolisticView";
		this.__COLUMNSETTING_ICON_ID = "nsSvgColumnSetting";
		
		this.util = new NSUtil();
		this.__objSVG = new NSSvg();
	};
	
	NSSvgShapes.prototype.addExportInPage = function() 
	{
		var EXPORT_ICON_VIEWPORT = "-0.329 0 512 427.534";
		var EXPORT_ICON_PATH_1 = "M383.552,350.474c-10.595,0-19.187,8.581-19.187,19.186v19.519H38.043V155.719H89.82c10.595,0,19.187-8.592,19.187-19.186   c0-10.598-8.592-19.187-19.187-19.187H18.857c-10.594,0-19.186,8.589-19.186,19.187v271.814c0,10.6,8.592,19.187,19.186,19.187   h364.694c10.594,0,19.186-8.587,19.186-19.187v-38.699C402.737,359.055,394.145,350.474,383.552,350.474z";
		var EXPORT_ICON_PATH_2 = "M506.051,146.306L365.355,5.621c-5.476-5.481-13.72-7.136-20.898-4.154c-7.179,2.971-11.842,9.965-11.842,17.722v63.27   c-73.23,3.333-131.281,26.065-172.753,67.695C96.71,213.54,96.298,297.112,96.308,300.629c0.032,8.684,5.899,16.269,14.299,18.479   c1.622,0.429,3.266,0.632,4.888,0.632c6.761,0,13.185-3.587,16.659-9.673c36.729-64.271,131.506-73.875,184.733-73.875   c5.889,0,11.183,0.117,15.717,0.3v64.067c0,7.763,4.674,14.754,11.842,17.72c7.189,2.986,15.423,1.327,20.898-4.154   l140.706-140.684c3.597-3.604,5.62-8.482,5.62-13.568C511.671,154.785,509.647,149.902,506.051,146.306z M370.976,254.238v-35.707   c0-9.788-7.366-18.011-17.093-19.068c-0.604-0.066-15.075-1.624-36.996-1.624c-45.166,0-116.522,6.525-169.616,42.047   c7.655-20.278,19.979-42.78,39.775-62.652c37.569-37.708,93.005-56.835,164.755-56.835c10.594,0,19.186-8.59,19.186-19.187V65.506   l94.362,94.367L370.976,254.238z";
		
		var groupExport = this.__objSVG.createGroup(this.__EXPORT_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__EXPORT_ICON_ID + "path1",EXPORT_ICON_PATH_1,null);
		groupExport.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__EXPORT_ICON_ID + "path2",EXPORT_ICON_PATH_2,null);
		groupExport.appendChild(path2);
		this.__objSVG.addElementInSymbol(this.__EXPORT_ICON_ID,EXPORT_ICON_VIEWPORT,groupExport);
	};
	
	NSSvgShapes.prototype.addMinimizeInPage = function() 
	{
		var MINIMIZE_ICON_VIEWPORT = "0 0 24 24";
		var MINIMIZE_ICON_PATH_1 = "M 0.00 0.00 L 1.83 0.00 C 1.86 1.25 1.24 1.86 -0.00 1.84 L 0.00 0.00 Z";
		var MINIMIZE_ICON_PATH_2 = "M 1.83 0.00 L 22.16 0.00 C 22.14 1.24 22.75 1.86 24.00 1.83 L 24.00 22.16 C 22.75 22.14 22.14 22.75 22.17 24.00 L 1.84 24.00 C 1.86 22.75 1.25 22.14 0.00 22.17 L 0.00 1.84 C 1.24 1.86 1.86 1.25 1.83 0.00 Z";
		var MINIMIZE_ICON_PATH_3 = "M 22.16 0.00 L 24.00 0.00 L 24.00 1.83 C 22.75 1.86 22.14 1.24 22.16 0.00 Z";
		var MINIMIZE_ICON_PATH_4 = "M 4.51 18.36 C 4.46 16.82 4.65 14.43 6.84 14.80 C 10.28 14.69 13.72 14.69 17.16 14.80 C 19.32 14.44 19.53 16.82 19.50 18.35 C 14.51 18.52 9.50 18.51 4.51 18.36 Z";
		var MINIMIZE_ICON_PATH_5 = "M 0.00 22.17 C 1.25 22.14 1.86 22.75 1.84 24.00 L 0.00 24.00 L 0.00 22.17 Z";
		var MINIMIZE_ICON_PATH_6 = "M 22.17 24.00 C 22.14 22.75 22.75 22.14 24.00 22.16 L 24.00 24.00 L 22.17 24.00 Z";
		
		var group = this.__objSVG.createGroup(this.__MINIMIZE_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__MINIMIZE_ICON_ID + "path1",MINIMIZE_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__MINIMIZE_ICON_ID + "path2",MINIMIZE_ICON_PATH_2,null);
		group.appendChild(path2);
		var path3 = this.__objSVG.createPath(this.__MINIMIZE_ICON_ID + "path3",MINIMIZE_ICON_PATH_3,null,"currentColor");
		group.appendChild(path3);
		var path4 = this.__objSVG.createPath(this.__MINIMIZE_ICON_ID + "path4",MINIMIZE_ICON_PATH_4,null,"currentColor");
		group.appendChild(path4);
		var path5 = this.__objSVG.createPath(this.__MINIMIZE_ICON_ID + "path5",MINIMIZE_ICON_PATH_5,null,"currentColor");
		group.appendChild(path5);
		var path6 = this.__objSVG.createPath(this.__MINIMIZE_ICON_ID + "path6",MINIMIZE_ICON_PATH_6,null,"currentColor");
		group.appendChild(path6);
		this.__objSVG.addElementInSymbol(this.__MINIMIZE_ICON_ID,MINIMIZE_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addMaximizeInPage = function() 
	{
		var MAXIMIZE_ICON_VIEWPORT = "0 0 24 24";
		var MAXIMIZE_ICON_PATH_1 = "M 0.00 0.00 L 3.24 0.00 C 2.36 1.26 1.28 2.36 0.00 3.22 L 0.00 0.00 Z";
		var MAXIMIZE_ICON_PATH_2 = "M 3.24 0.00 L 20.80 0.00 C 21.64 1.28 22.73 2.37 24.00 3.24 L 24.00 20.78 C 22.73 21.65 21.63 22.72 20.77 24.00 L 3.21 24.00 C 2.36 22.72 1.26 21.64 0.00 20.75 L 0.00 3.22 C 1.28 2.36 2.36 1.26 3.24 0.00 Z";
		var MAXIMIZE_ICON_PATH_3 = "M 20.80 0.00 L 24.00 0.00 L 24.00 3.24 C 22.73 2.37 21.64 1.28 20.80 0.00 Z";
		var MAXIMIZE_ICON_PATH_4 = "M 4.62 6.53 C 9.54 6.41 14.46 6.41 19.38 6.53 C 19.42 10.49 19.42 14.45 19.37 18.42 C 14.46 18.51 9.55 18.51 4.63 18.42 C 4.57 14.45 4.58 10.50 4.62 6.53 Z";
		var MAXIMIZE_ICON_PATH_5 = "M 6.48 10.21 C 10.16 10.23 13.84 10.22 17.52 10.21 C 17.51 12.34 17.52 14.47 17.53 16.60 C 13.84 16.59 10.16 16.59 6.48 16.60 C 6.48 14.47 6.48 12.34 6.48 10.21 Z";
		var MAXIMIZE_ICON_PATH_6 = "M 0.00 20.75 C 1.26 21.64 2.36 22.72 3.21 24.00 L 0.00 24.00 L 0.00 20.75 Z";
		var MAXIMIZE_ICON_PATH_7 = "M 20.77 24.00 C 21.63 22.72 22.73 21.65 24.00 20.78 L 24.00 24.00 L 20.77 24.00 Z";
		
		var group = this.__objSVG.createGroup(this.__MAXIMIZE_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path1",MAXIMIZE_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path2",MAXIMIZE_ICON_PATH_2,null);
		group.appendChild(path2);
		var path3 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path3",MAXIMIZE_ICON_PATH_3,null,"currentColor");
		group.appendChild(path3);
		var path4 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path4",MAXIMIZE_ICON_PATH_4,null,"currentColor");
		group.appendChild(path4);
		var path5 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path5",MAXIMIZE_ICON_PATH_5,null);
		group.appendChild(path5);
		var path6 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path6",MAXIMIZE_ICON_PATH_6,null,"currentColor");
		group.appendChild(path6);
		var path7 = this.__objSVG.createPath(this.__MAXIMIZE_ICON_ID + "path7",MAXIMIZE_ICON_PATH_7,null,"currentColor");
		group.appendChild(path7);
		this.__objSVG.addElementInSymbol(this.__MAXIMIZE_ICON_ID,MAXIMIZE_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addExpandInPage = function() 
	{
		var EXPAND_ICON_VIEWPORT = "0 0 48 48";
		var EXPAND_ICON_PATH_1 = "M 0 0 L 0 48 L 48 48 L 48 0 Z";
		var EXPAND_ICON_PATH_2 = "M33.17 17.17l-9.17 9.17-9.17-9.17-2.83 2.83 12 12 12-12z";
		var EXPAND_ICON_PATH_3 = "M0 0h48v48h-48z";
		
		var group = this.__objSVG.createGroup(this.__EXPAND_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__EXPAND_ICON_ID + "path1",EXPAND_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__EXPAND_ICON_ID + "path2",EXPAND_ICON_PATH_2,null,null);
		group.appendChild(path2);
		var path3 = this.__objSVG.createPath(this.__EXPAND_ICON_ID + "path3",EXPAND_ICON_PATH_3,null,"none");
		group.appendChild(path3);
		this.__objSVG.addElementInSymbol(this.__EXPAND_ICON_ID,EXPAND_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addCollapseInPage = function() 
	{
		var COLLAPSE_ICON_VIEWPORT = "0 0 48 48";
		var COLLAPSE_ICON_PATH_1 = "M 0 0 L 0 48 L 48 48 L 48 0 Z";
		var COLLAPSE_ICON_PATH_2 = "M24 16l-12 12 2.83 2.83 9.17-9.17 9.17 9.17 2.83-2.83z";
		var COLLAPSE_ICON_PATH_3 = "M0 0h48v48h-48z";
		
		var group = this.__objSVG.createGroup(this.__COLLAPSE_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__COLLAPSE_ICON_ID + "path1",COLLAPSE_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__COLLAPSE_ICON_ID + "path2",COLLAPSE_ICON_PATH_2,null,null);
		group.appendChild(path2);
		var path3 = this.__objSVG.createPath(this.__COLLAPSE_ICON_ID + "path3",COLLAPSE_ICON_PATH_3,null,"none");
		group.appendChild(path3);
		this.__objSVG.addElementInSymbol(this.__COLLAPSE_ICON_ID,COLLAPSE_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addFullScreenInPage = function() 
	{
		var VIEWPORT = "0 0 23.65 23.65";
		var FULLSCREEN_ICON_PATH_1 = "M 0 0 L 0 23.65 L 23.65 23.65 L 23.65 0 Z";
		var FULLSCREEN_ICON_PATH_2 = "M0.587,0.057l6.529,0.621c0,0,0.869-0.027,0.383,0.457C7.011,1.624,5.833,2.801,5.833,2.801" +
									"S6.12,3.09,6.563,3.526c1.254,1.258,3.539,3.543,4.469,4.473c0,0,0.318,0.189-0.064,0.57c-0.383,0.387-2.072,2.068-2.346,2.344" +
									"c-0.268,0.273-0.475,0.057-0.475,0.057c-0.904-0.904-3.27-3.266-4.484-4.482C3.271,6.092,3.015,5.835,3.015,5.835" +
									"S2.067,6.78,1.474,7.374c-0.59,0.592-0.588-0.299-0.588-0.299S0.062,1.225,0.062,0.52C0.062,0.016,0.587,0.057,0.587,0.057z";
		var FULLSCREEN_ICON_PATH_3 = "M23.122,23.608l-6.523-0.621c0,0-0.871,0.025-0.387-0.461c0.486-0.484,1.666-1.666,1.666-1.666" +
									"s-0.287-0.285-0.727-0.723c-1.256-1.26-3.541-3.543-4.471-4.479c0,0-0.322-0.18,0.062-0.564s2.07-2.07,2.346-2.344" +
									"c0.271-0.275,0.477-0.059,0.477-0.059c0.902,0.906,3.27,3.27,4.482,4.482c0.393,0.395,0.65,0.654,0.65,0.654" +
									"s0.949-0.947,1.541-1.541c0.59-0.592,0.59,0.301,0.59,0.301s0.822,5.854,0.822,6.549C23.651,23.647,23.122,23.608,23.122,23.608z";
		var FULLSCREEN_ICON_PATH_4 = "M0.001,23.094l0.615-6.531c0,0-0.023-0.869,0.465-0.383c0.484,0.486,1.664,1.668,1.664,1.668" +
									"S3.03,17.561,3.47,17.12c1.256-1.256,3.541-3.541,4.475-4.475c0,0,0.184-0.316,0.568,0.066c0.383,0.387,2.07,2.072,2.344,2.346" +
									"c0.273,0.271,0.055,0.477,0.055,0.477c-0.906,0.904-3.266,3.27-4.48,4.486c-0.395,0.393-0.652,0.648-0.652,0.648" +
									"s0.945,0.947,1.537,1.537c0.592,0.594-0.297,0.59-0.297,0.59s-5.85,0.824-6.551,0.824C-0.042,23.62,0.001,23.094,0.001,23.094z";
		var FULLSCREEN_ICON_PATH_5 = "M23.552,0.557l-0.615,6.529c0,0,0.023,0.869-0.461,0.383c-0.49-0.49-1.668-1.664-1.668-1.664" +
									"s-0.286,0.286-0.725,0.725c-1.256,1.256-3.543,3.541-4.475,4.473c0,0-0.184,0.318-0.568-0.066s-2.068-2.066-2.346-2.34" +
									"c-0.27-0.279-0.057-0.482-0.057-0.482c0.906-0.904,3.27-3.268,4.484-4.48c0.396-0.395,0.65-0.652,0.65-0.652" +
									"s-0.943-0.945-1.537-1.539c-0.592-0.592,0.299-0.586,0.299-0.586s5.849-0.828,6.552-0.828C23.595,0.03,23.552,0.557,23.552,0.557z";
		var group = this.__objSVG.createGroup(this.__FULLSCREEN_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__FULLSCREEN_ICON_ID + "path1",FULLSCREEN_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__FULLSCREEN_ICON_ID + "path2",FULLSCREEN_ICON_PATH_2,null,null);
		group.appendChild(path2);
		var path3 = this.__objSVG.createPath(this.__FULLSCREEN_ICON_ID + "path3",FULLSCREEN_ICON_PATH_3,null,null);
		group.appendChild(path3);
		var path4 = this.__objSVG.createPath(this.__FULLSCREEN_ICON_ID + "path4",FULLSCREEN_ICON_PATH_4,null,null);
		group.appendChild(path4);
		var path5 = this.__objSVG.createPath(this.__FULLSCREEN_ICON_ID + "path5",FULLSCREEN_ICON_PATH_5,null,null);
		group.appendChild(path5);
		this.__objSVG.addElementInSymbol(this.__FULLSCREEN_ICON_ID,VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addRestoreInPage = function() 
	{
		var VIEWPORT = "0 0 32 32";
		var RESTORE_ICON_PATH_1 = "M 0 0 L 0 32 L 32 32 L 32 0 Z";
		var RESTORE_ICON_PATH_2 = "22.586,25.414 29.172,32 32,29.172 25.414,22.586 28,20 20,20 20,28";
		var RESTORE_ICON_PATH_3 = "6.547,9.371 4,12 11.961,11.957 12,4 9.375,6.543 2.828,0 0,2.828";
		var RESTORE_ICON_PATH_4 = "0,29.172 2.828,32 9.414,25.414 12,28 12,20 4,20 6.586,22.586";
		var RESTORE_ICON_PATH_5 = "28.031,12 25.438,9.404 32,2.838 29.164,0 22.598,6.566 20,3.971 20,12";
		var group = this.__objSVG.createGroup(this.__RESTORE_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__RESTORE_ICON_ID + "path1",RESTORE_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPolygon(this.__RESTORE_ICON_ID + "path2",RESTORE_ICON_PATH_2,null);
		group.appendChild(path2);
		var path3 = this.__objSVG.createPolygon(this.__RESTORE_ICON_ID + "path3",RESTORE_ICON_PATH_3,null);
		group.appendChild(path3);
		var path4 = this.__objSVG.createPolygon(this.__RESTORE_ICON_ID + "path4",RESTORE_ICON_PATH_4,null);
		group.appendChild(path4);
		var path5 = this.__objSVG.createPolygon(this.__RESTORE_ICON_ID + "path5",RESTORE_ICON_PATH_5,null);
		group.appendChild(path5);
		this.__objSVG.addElementInSymbol(this.__RESTORE_ICON_ID,VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addFilterIcon = function()
	{
		var FILTER_ICON_VIEWPORT = "0 0 14.00 16.80";
		var FILTER_ICON_PATH = "M 1.39999,0L 0,1.40002L 5.60001,8.40002L 5.60001,14L 8.39999," +
							   "16.8L 8.39999,8.40002L 14,1.40002L 12.6," +
							   "0L 1.39999,0 Z M 2.79999,2.80005L 11.2,2.80005L 6.99997,7L 2.79999,2.80005 Z";
		var group = this.__objSVG.createGroup(this.__FILTER_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__FILTER_ICON_ID + "path",FILTER_ICON_PATH,null,null);
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__FILTER_ICON_ID,FILTER_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addSearchIcon = function()
	{
		var SEARCH_ICON_VIEWPORT = "0 0 250.313 250.313";
		var SEARCH_ICON_PATH = "M244.186,214.604l-54.379-54.378c-0.289-0.289-0.628-0.491-0.93-0.76" + 
							   "c10.7-16.231,16.945-35.66,16.945-56.554C205.822,46.075,159.747,0,102.911,0S0,46.075,0,102.911" + 
							   "c0,56.835,46.074,102.911,102.91,102.911c20.895,0,40.323-6.245,56.554-16.945c0.269,0.301,0.47,0.64,0.759,0.929l54.38,54.38" + 
							   "c8.169,8.168,21.413,8.168,29.583,0C252.354,236.017,252.354,222.773,244.186,214.604z M102.911,170.146" + 
							   "c-37.134,0-67.236-30.102-67.236-67.235c0-37.134,30.103-67.236,67.236-67.236c37.132,0,67.235,30.103,67.235,67.236" + 
							   "C170.146,140.044,140.043,170.146,102.911,170.146z";
		var group = this.__objSVG.createGroup(this.__SEARCH_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__SEARCH_ICON_ID + "path",SEARCH_ICON_PATH,null,null);
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__SEARCH_ICON_ID,SEARCH_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addCloseIcon = function()
	{
		var CLOSE_ICON_VIEWPORT = "0 0 24 24";
		var CLOSE_ICON_PATH_1 = "M 0 0 L 0 24 L 24 24 L 24 0 Z";
		var CLOSE_ICON_PATH_2 = "M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  " +
								"c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141," +
								"0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  " +
								"c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  " +
								"L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z";
		var group = this.__objSVG.createGroup(this.__CLOSE_ICON_ID + "group");
		var path1 = this.__objSVG.createPath(this.__CLOSE_ICON_ID + "path1",CLOSE_ICON_PATH_1,null,"currentColor");
		group.appendChild(path1);
		var path2 = this.__objSVG.createPath(this.__CLOSE_ICON_ID + "path2",CLOSE_ICON_PATH_2,null);
		group.appendChild(path2);
		this.__objSVG.addElementInSymbol(this.__CLOSE_ICON_ID,CLOSE_ICON_VIEWPORT,group);
	};
	
	
	
	NSSvgShapes.prototype.addTreeIcon = function()
	{
		var TREE_ICON_VIEWPORT = "0 0 16.58 15.80";
		var TREE_ICON_PATH = "M 11.7581,6.66565C 11.7581,6.66565 11.3116,6.38879 10.6755,7.20532C 10.0394,7.85571 9.99429," +
				"8.29395 9.99429,8.29395C 9.99429,8.29395 9.90411,7.28833 10.256,6.58264C 10.6078,5.87683 11.3116,5.76611 11.7041," +
				"5.72461C 11.5417,5.55847 11.4785,5.44775 10.7071,5.48938C 9.9357,5.53088 9.57938,5.95056 9.57938,5.95056C 9.57938," +
				"5.95056 9.78674,5.48938 9.92218,5.35095C 10.7206,4.68665 12.1778,5.34167 12.1778,5.34167C 12.1778,5.34167 12.1778," +
				"5.06506 11.9117,4.83887C 11.6455,4.61292 10.7206,4.65906 10.7206,4.65906C 10.7206,4.65906 11.6274,4.17932 12.1778," +
				"4.49304C 12.7281,4.80664 12.6138,5.12036 12.8318,5.43396C 13.0439,5.06506 13.5222,4.58984 14.2393,4.63147C 14.9565," +
				"4.67297 15.3492,4.81128 16.0574,5.6554C 15.6423,5.42004 15.3355,5.32336 14.7762,5.37854C 14.2167,5.43396 13.9101,5.53088 13.9101," +
				"5.77991C 14.4018,5.6969 15.3762,5.95056 15.8769,6.66565C 16.3776,7.38062 16.1054,8.19397 16.2197,8.95813C 15.6423,7.88342 15.2588" +
				",7.15918 14.7762,6.8363C 14.2936,6.51343 13.9101,6.51343 13.5085,6.62415C 13.7251,6.8363 14.1176,7.27454 14.0904,8.18774C 14.0634" +
				",9.10107 13.0439,10.3789 12.7371,10.3789C 12.8395,9.88074 12.8453,10.1252 13.0439,8.88428C 13.1724,8.08081 13.0512,7.63123 12.8518" +
				",7.30273L 12.0176,9.84802L 11.5801,12.4558L 9.57986,12.4559L 8.89246,9.43005L 6.63654,4.65344L 6.25824,3.77332L 6.85547" +
				",3.75793L 8.36816,6.34778L 10.5798,10.8745L 11.9063,7.61487L 12.3238,6.79846L 11.7581,6.66565 Z M 5.74124,3.65503C 5.18652" +
				",4.28601 4.57645,4.89587 4.88147,6.8031C 5.18652,8.71033 5.1958,8.33459 5.35303,9.10034C 4.88147,9.10034 3.31439,7.13635 3.27274" +
				",5.73254C 3.23123,4.32861 3.8345,3.65503 4.16736,3.32886C 3.55011,3.15881 2.96072,3.15881 2.21878,3.65503C 1.47684,4.15137 0.887573" +
				",5.26453 -6.10352e-005,6.9165C 0.175598,5.74194 -0.242737,4.4917 0.527008,3.3927C 1.29663,2.29382 2.79434,1.90381 3.55011" +
				",2.03149C 3.55011,1.64856 3.07874,1.49963 2.21878,1.41455C 1.35901,1.32947 0.887573,1.47839 0.249664,1.83997C 1.33829," +
				"0.54248 1.94156,0.329834 3.04407,0.265991C 4.14651,0.202148 4.88147,0.932495 5.20734,1.49963C 5.54251,1.01758 5.36685" +
				",0.5354 6.21283,0.0532227C 7.05878,-0.428833 8.45245,0.308594 8.45245,0.308594C 8.45245,0.308594 7.03113,0.237671 6.62189" +
				",0.585083C 6.21283,0.932495 6.21283,1.35779 6.21283,1.35779C 6.21283,1.35779 8.45245,0.351074 9.67981,1.37207C 9.88785" +
				",1.58472 10.2067,2.29382 10.2067,2.29382C 10.2067,2.29382 9.65897,1.64856 8.4733,1.58472C 7.28763,1.52087 7.19046,1.69104 6.94092" +
				",1.94641C 7.54419,2.01013 8.62585,2.1803 9.16675,3.26501C 9.70746,4.34985 9.56879,5.89551 9.56879,5.89551C 9.56879,5.89551 9.49945" +
				",5.22192 8.52179,4.22229C 7.54419,2.96729 6.85773,3.3927 6.85773,3.3927L 5.74124,3.65503 Z M 2.57837,13.8029L 6.05347,13.1345L 9.57922," +
				"12.8025L 11.5793,12.8025L 15.5798,13.8029L 16.5799,14.8031L 13.5796,14.8031L 12.5795,15.8036L 8.5791,15.8036L 6.57889,14.8031L 1.57855," +
				"14.98L 2.57837,13.8029 Z ";
		var group = this.__objSVG.createGroup(this.__TREE_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__TREE_ICON_ID + "path",TREE_ICON_PATH,null,null);
		path.setAttribute("fill","#2B2B2B");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__TREE_ICON_ID,TREE_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addExportIcon = function()
	{
		var EXPORT_ICON_VIEWPORT = "0 0 18.00 14.40";
		var EXPORT_ICON_PATH = "M 0.000244141,6.10352e-005L 4.80011,6.10352e-005L 8.39996,3.59991L 11.9998,0L 16.7999,0L 16.7999," +
				"2.39996L 12.0001,7.20001L 12,8.39996L 16.7999,8.39996L 16.7999,9.59998L 15.6001,10.8L 18,13.2L 18,14.4L 14.4," +
				"14.4L 14.4,13.1999L 6.10352e-005,13.1999L 6.10352e-005,11.9999L 4.79999,7.19995L 0,2.39996L 0.000244141," +
				"6.10352e-005 Z M 1.19989,1.20007L 3.60028,1.19995L 14.4001,11.9999L 12.0001,11.9999L 1.19989,1.20007 Z";
		var group = this.__objSVG.createGroup(this.__EXPORT_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__EXPORT_ICON_ID + "path",EXPORT_ICON_PATH,null,null);
		path.setAttribute("fill","#3F3F3F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__EXPORT_ICON_ID,EXPORT_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addMoveIcon = function()
	{
		var MOVE_ICON_VIEWPORT = "0 0 18.00 22.00";
		var MOVE_ICON_PATH = "M 8.00006,2L 10.0001,2L 10.0001,4L 8.00006,4L 8.00006,2 Z M 8,6L 10,6L 10,8L 8," +
				"8L 8,6 Z M 8,10L 10,10L 10,12L 8,12L 8,10 Z M 8,14L 10,14L 10,16L 8,16L 8,14 Z M 8,18L 10,18L 10,20L 8,20L 8,18 Z";
		var group = this.__objSVG.createGroup(this.__MOVE_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__MOVE_ICON_ID + "path",MOVE_ICON_PATH,null,null);
		path.setAttribute("fill","#909090");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__MOVE_ICON_ID,MOVE_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addLeftIcon = function()
	{
		var LEFT_ICON_VIEWPORT = "0 0 11.00 8.00";
		var LEFT_ICON_PATH = "M 11,5.99921L 5.00073,5.99921L 5.00073,7.99896L 0,4.00006L 5.00073,6.10352e-005L 5.00073,1.99969L 11,1.99969L 11,5.99921 Z";
		var group = this.__objSVG.createGroup(this.__LEFT_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__LEFT_ICON_ID + "path",LEFT_ICON_PATH,null,null);
		path.setAttribute("fill","#282828");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__LEFT_ICON_ID,LEFT_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addRightIcon = function()
	{
		var RIGHT_ICON_VIEWPORT = "0 0 11.00 8.00";
		var RIGHT_ICON_PATH = "M 0,1.99976L 5.99927,1.99976L 5.99927,0L 11,3.9989L 5.99927,7.9989L 5.99927,5.99927L 0,5.99927L 0,1.99976 Z ";
		var group = this.__objSVG.createGroup(this.__RIGHT_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__RIGHT_ICON_ID + "path",RIGHT_ICON_PATH,null,null);
		path.setAttribute("fill","#282828");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__RIGHT_ICON_ID,RIGHT_ICON_VIEWPORT,group);
	};
	
	
	NSSvgShapes.prototype.addHistoryIcon = function()
	{
		var HISTORY_ICON_VIEWPORT = "0 0 15.00 15.00";
		var HISTORY_ICON_PATH = "M 7.5,-1.52588e-005C 11.6422,-1.52588e-005 15,3.35789 15,7.49998C 15,11.6422 11.6421,15 7.5,15C 3.35787,15 0,11.6422 0," +
				"7.49998C 0,3.35789 3.35785,-1.52588e-005 7.5,-1.52588e-005 Z M 7.49998,1.99998C 4.46234,1.99998 1.99987,4.46239 1.99987,7.50005C 1.99987," +
				"10.5377 4.46235,13.0002 7.49998,13.0002C 10.5376,13.0002 13.0001,10.5377 13.0001,7.50005C 13.0001,4.46239 10.5376,1.99998 7.49998," +
				"1.99998 Z M 6.00001,3.99998L 8,3.99998L 8,6.99998L 11,6.99998L 11,8.99998L 6,8.99998L 6.00001,7.99998L 6,6.99998L 6.00001,3.99998 Z ";
		var group = this.__objSVG.createGroup(this.__HISTORY_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__HISTORY_ICON_ID + "path",HISTORY_ICON_PATH,null,null);
		path.setAttribute("fill","#3F3F3F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__HISTORY_ICON_ID,HISTORY_ICON_VIEWPORT,group);
	};
	 
	
	NSSvgShapes.prototype.addPendingIcon = function()
	{
		var PENDING_ICON_VIEWPORT = "0 0 12.00 14.00";
		var PENDING_ICON_PATH = "M 1,2.00016L 11,2.00004L 11.0001,3.99986L 8.00012,6.99967L 7.99927,6.99986L 8.00004,6.99986L 11.0002,9.99937L 11.0001,11L 11.0001,12L 1.00016,12L 1.00016,11L 1.00041,9.99955L 4.00008,6.99986L 1.00004,4.00004L 1,2.00016 Z M 0,0.000160217L 12,3.8147e-005L 12," +
				"1.00004L 0,1.00016L 0,0.000160217 Z M 0,13.0002L 12,13L 12,14L 0,14.0002L 0,13.0002 Z M 3.00004,5.00004L 9.00008,4.99986L 7.00008," +
				"6.99986L 5.00004,7.00004L 3.00004,5.00004 Z M 2.00008,10.9999L 10.0001,10.9997L 10.0001,9.99967L 7.00012,7.99967L 5.00008," +
				"7.99986L 2.00008,9.99986L 2.00008,10.9999 Z ";
		var group = this.__objSVG.createGroup(this.__PENDING_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__PENDING_ICON_ID + "path",PENDING_ICON_PATH,null,null);
		path.setAttribute("fill","#3F3F3F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__PENDING_ICON_ID,PENDING_ICON_VIEWPORT,group);
	};
	 
	
	NSSvgShapes.prototype.addSupervisorIcon = function()
	{
		var SUPERVISOR_ICON_VIEWPORT = "0 0 14.00 14.01";
		var SUPERVISOR_ICON_PATH = "M 10.2679,7.15833L 11.388,9.45691L 14.0016,9.77368L 12.0803,11.511L 12.5755,14.0054L 10.2679," +
				"12.7805L 7.96036,14.0054L 8.45554,11.511L 6.53418,9.77368L 9.14783,9.45691L 10.2679,7.15833 Z M 3.05176e-005," +
				"11.2043C 3.05176e-005,7.64325 1.7113,8.45258 4.04489,7.15759C 4.19977,7.07166 4.02631,5.94464 3.88931," +
				"5.86267C 3.37726,5.55652 3.54456,5.15356 3.42261,4.56775C 3.1698,3.35376 2.98596,2.25751 3.42261,1.49231C 4.5174," +
				"-0.426392 6.68039,-0.568359 7.9342,1.49231C 8.42841,2.30457 8.08359,3.50476 7.9342,4.56775C 7.84033,5.23511 8.03143," +
				"5.50861 7.46747,5.86267C 7.31366,5.95923 7.13449,7.10297 7.31183,7.15765C 8.01917,7.37561 8.62146,7.49121 9.12555," +
				"7.61108L 8.71188,8.71448L 4.97815,9.33698L 6.84497,11.2043L 3.05176e-005,11.2043 Z  ";
		var group = this.__objSVG.createGroup(this.__SUPERVISOR_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__SUPERVISOR_ICON_ID + "path",SUPERVISOR_ICON_PATH,null,null);
		path.setAttribute("fill","#3F3F3F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__SUPERVISOR_ICON_ID,SUPERVISOR_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addEntityIcon = function()
	{
		var ENTITY_ICON_VIEWPORT = "0 0 12.00 12.00";
		var ENTITY_ICON_PATH = "M 0,1.52588e-005L 12,1.52588e-005L 12,12L 0,12L 0,1.52588e-005 Z M 8.31001,9.84993L 3.69,9.84993L 3.69," +
				"2.14992L 8.09,2.14992L 8.09,3.57991L 5.45,3.57991L 5.45,5.22987L 7.98,5.22987L 7.98,6.65993L 5.45,6.65993L 5.45,8.41994L 8.31001," +
				"8.41994L 8.31001,9.84993 Z";
		var group = this.__objSVG.createGroup(this.__ENTITY_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__ENTITY_ICON_ID + "path",ENTITY_ICON_PATH,null,null);
		path.setAttribute("fill","#707070");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__ENTITY_ICON_ID,ENTITY_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addDivisionIcon = function()
	{
		var DIVISION_ICON_VIEWPORT = "0 0 12.00 12.00";
		var DIVISION_ICON_PATH = "M 0,4.57764e-005L 12,4.57764e-005L 12,12L 0,12L 0,4.57764e-005 Z M 2.53501,9.84996L 2.53501,2.15001L 5.30219," +
				"2.15001C 8.0774,2.15001 9.46501,3.40123 9.46501,5.90373C 9.46501,7.10228 9.08631,8.05962 8.32892,8.77574C 7.57151,9.49193 6.5626," +
				"9.84996 5.30219,9.84996L 2.53501,9.84996 Z M 4.295,3.57994L 4.295,8.41997L 5.16125,8.41997C 5.92094,8.41997 6.51648,8.19627 6.9479," +
				"7.74883C 7.37931,7.30138 7.59501,6.69261 7.59501,5.92265C 7.59501,5.19505 7.38102,4.62267 6.95305,4.20561C 6.52509,3.78856 5.92438," +
				"3.57994 5.15094,3.57994L 4.295,3.57994 Z";
		var group = this.__objSVG.createGroup(this.__DIVISION_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__DIVISION_ICON_ID + "path",DIVISION_ICON_PATH,null,null);
		path.setAttribute("fill","#707070");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__DIVISION_ICON_ID,DIVISION_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addGroupIcon = function()
	{
		var GROUP_ICON_VIEWPORT = "0 0 13.00 10.00";
		var GROUP_ICON_PATH = "M 11.9985,4.00386L 1.99975,4.00392L 0,9.0005L 0,0.00672913L 2.99981,1.52588e-005L 4.99954,1.99867L 11.9985," +
				"2.00533L 11.9985,4.00386 Z M 12.9985,4.99684L 10.9988,9.99342L 0.999805,10L 2.9996,5.00343L 12.9985,4.99684 Z";
		var group = this.__objSVG.createGroup(this.__GROUP_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__GROUP_ICON_ID + "path",GROUP_ICON_PATH,null,null);
		path.setAttribute("fill","#707070");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__GROUP_ICON_ID,GROUP_ICON_VIEWPORT,group);
	};
	
	
	NSSvgShapes.prototype.addHierarchyIcon = function()
	{
		var HIERARCHY_ICON_VIEWPORT = "0 0 12.00 12.00";
		var HIERARCHY_ICON_PATH = "M 0,3.05176e-005L 12,3.05176e-005L 12,12L 0,12L 0," +
				"3.05176e-005 Z M 2.69484,2.30722L 3.90313,2.30722L 3.90313,5.2858L 8.09688," +
				"5.2858L 8.09688,2.30722L 9.30516,2.30722L 9.30516,9.69266L 8.09688," +
				"9.69266L 8.09688,6.38406L 3.90313,6.38406L 3.90313,9.69266L 2.69484," +
				"9.69266L 2.69484,2.30722 Z ";
		var group = this.__objSVG.createGroup(this.__HIERARCHY_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__HIERARCHY_ICON_ID + "path",HIERARCHY_ICON_PATH,null,null);
		path.setAttribute("fill","#707070");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__HIERARCHY_ICON_ID,HIERARCHY_ICON_VIEWPORT,group);
	};
	
	
	NSSvgShapes.prototype.addEqualIcon = function()
	{
		var EQUAL_ICON_VIEWPORT = "0 0 7.63 5.76";
		var EQUAL_ICON_PATH = "M 0,0L 7.62986,0L 7.62986,2.30396L 0,2.30396L 0," +
				"0 Z M 0,3.45599L 7.62986,3.45599L 7.62986,5.75995L 0,5.75995L 0,3.45599 Z";
		var group = this.__objSVG.createGroup(this.__EQUAL_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__EQUAL_ICON_ID + "path",EQUAL_ICON_PATH,null,null);
		path.setAttribute("fill","#7AC08F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__EQUAL_ICON_ID,EQUAL_ICON_VIEWPORT,group);
	};
	
	
	NSSvgShapes.prototype.addGreaterIcon = function()
	{
		var GREATER_ICON_VIEWPORT = "0 0 8.06 8.78";
		var GREATER_ICON_PATH = "M 0,8.78406L 8.06175,5.48553L 8.06175,3.29852L 0," +
				"6.10352e-005L 0,2.48181L 4.89913,4.39203L 0,6.30231L 0,8.78406 Z ";
		var group = this.__objSVG.createGroup(this.__GREATER_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__GREATER_ICON_ID + "path",GREATER_ICON_PATH,null,null);
		path.setAttribute("fill","#7AC08F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__GREATER_ICON_ID,GREATER_ICON_VIEWPORT,group);
	};
	
	
	NSSvgShapes.prototype.addGreaterEqualIcon = function()
	{
		var GREATEREQUAL_ICON_VIEWPORT = "0 0 8.06 8.78";
		var GREATEREQUAL_ICON_PATH = "M 0,8.78406L 8.06175,5.48553L 8.06175,3.29852L 0," +
				"6.10352e-005L 0,2.48181L 4.89913,4.39203L 0,6.30231L 0,8.78406 Z ";
		var group = this.__objSVG.createGroup(this.__GREATEREQUAL_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__GREATEREQUAL_ICON_ID + "path",GREATEROPEN_ICON_PATH,null,null);
		path.setAttribute("fill","#7AC08F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__GREATEREQUAL_ICON_ID,GREATEREQUAL_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addLessIcon = function()
	{
		var LESS_ICON_VIEWPORT = "0 0 8.06 8.78";
		var LESS_ICON_PATH = "M 8.06175,8.78406L 0,5.48553L 0,3.29852L 8.06175,6.10352e-005L 8.06175,2.48181L 3.16262," +
				"4.39203L 8.06175,6.30231L 8.06175,8.78406 Z";
		var group = this.__objSVG.createGroup(this.__LESS_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__LESS_ICON_ID + "path",LESS_ICON_PATH,null,null);
		path.setAttribute("fill","#7AC08F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__LESS_ICON_ID,LESS_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addLessEqualIcon = function()
	{
		var LESSEQUAL_ICON_VIEWPORT = "0 0 8.06 11.66";
		var LESSEQUAL_ICON_PATH = "M 8.06177,8.78395L 0,5.50795L 0,3.2737L 8.06177,-4.57764e-005L 8.06177," +
				"2.4839L 3.12888,4.39198L 8.06177,6.3022L 8.06177,8.78395 Z M 0,9.36L 8.06177," +
				"9.36L 8.06177,11.664L 0,11.664L 0,9.36 Z ";
		var group = this.__objSVG.createGroup(this.__LESSEQUAL_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__LESSEQUAL_ICON_ID + "path",LESSEQUAL_ICON_PATH,null,null);
		path.setAttribute("fill","#7AC08F");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__LESSEQUAL_ICON_ID,LESSEQUAL_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addFocusViewIcon = function()
	{
		var FOCUSVIEW_ICON_VIEWPORT = "0 0 21.77 14.00";
		var FOCUSVIEW_ICON_PATH = "M 0,9.91821e-005L 3.11017,9.91821e-005L 3.11017,14L 0,14L 0,9.91821e-005 Z M 4.66608," +
				"-2.28882e-005L 21.772,-2.28882e-005L 21.772,13.9999L 4.66608,13.9999L 4.66608,-2.28882e-005 Z M 7.77557," +
				"3.11118L 18.6613,3.11118L 18.6613,4.66679L 7.77557,4.66679L 7.77557,3.11118 Z M 7.77557,6.22233L 18.6613,6.22233L 18.6613," +
				"7.77787L 7.77557,7.77787L 7.77557,6.22233 Z M 7.77557,9.33341L 18.6613,9.33341L 18.6613,10.889L 7.77557,10.889L 7.77557,9.33341 Z ";
		var group = this.__objSVG.createGroup(this.__FOCUSVIEW_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__FOCUSVIEW_ICON_ID + "path",FOCUSVIEW_ICON_PATH,null,null);
		path.setAttribute("fill","#494949");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__FOCUSVIEW_ICON_ID,FOCUSVIEW_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addHolisticViewIcon = function()
	{
		var HOLISTICVIEW_ICON_VIEWPORT = "0 0 20.22 14.00";
		var HOLISTICVIEW_ICON_PATH = "M 0.00012207,0L 20.2158,0L 20.2158,14L 0.00012207,14L 0.00012207,0 Z M 1.55432,1.5556L 6.21985," +
				"1.5556L 6.21985,3.11121L 1.55432,3.11115L 1.55432,1.5556 Z M 1.55432,4.66669L 6.21985,4.66681L 6.21985," +
				"6.22229L 1.55432,6.22223L 1.55432,4.66669 Z M 1.55432,7.77783L 6.21985,7.77789L 6.21985,9.33344L 1.55432," +
				"9.33331L 1.55432,7.77783 Z M 1.55432,10.889L 6.2196,10.889L 6.2196,12.4445L 1.55432,12.4445L 1.55432," +
				"10.889 Z M 7.77454,1.5556L 12.4403,1.5556L 12.4403,3.11121L 7.77454,3.11115L 7.77454,1.5556 Z M 7.77454" +
				",4.66669L 12.4403,4.66681L 12.4403,6.22229L 7.77454,6.22223L 7.77454,4.66669 Z M 7.77454,7.77783L 12.4403," +
				"7.77789L 12.4403,9.33344L 7.77454,9.33331L 7.77454,7.77783 Z M 7.77502,10.889L 12.4403,10.889L 12.4403," +
				"12.4445L 7.77502,12.4445L 7.77502,10.889 Z M 13.9952,1.5556L 18.6606,1.5556L 18.6606,3.11121L 13.9952," +
				"3.11115L 13.9952,1.5556 Z M 13.9952,4.66669L 18.6606,4.66681L 18.6606,6.22229L 13.9952,6.22223L 13.9952," +
				"4.66669 Z M 13.9952,7.77783L 18.6606,7.77789L 18.6606,9.33344L 13.9952,9.33331L 13.9952,7.77783 Z M 13.9952," +
				"10.889L 18.6609,10.889L 18.6609,12.4445L 13.9952,12.4445L 13.9952,10.889 Z";
		var group = this.__objSVG.createGroup(this.__HOLISTICVIEW_ICON_ID + "group");
		var path = this.__objSVG.createPath(this.__HOLISTICVIEW_ICON_ID + "path",HOLISTICVIEW_ICON_PATH,null,null);
		path.setAttribute("fill","#494949");
		path.setAttribute("fill-rule","evenodd");
		group.appendChild(path);
		this.__objSVG.addElementInSymbol(this.__HOLISTICVIEW_ICON_ID,HOLISTICVIEW_ICON_VIEWPORT,group);
	};
	
	NSSvgShapes.prototype.addColumnSettingIcon = function() 
	{
        var COLUMNSETTING_ICON_VIEWPORT = "0 0 1000 1000";
        var COLUMNSETTING_ICON_PATH = "M898.1,10H668.4h-30.6H362.2h-30.6H101.9C51.1,10,10,51.1,10,101.9v229.7v566.6c0,50.7,41.1,91.9,91.9,91.9h229.7h30.6h275.6h30.6h229.7c50.7,0,91.9-41.1,91.9-91.9V331.6V101.9C990,51.1,948.9,10,898.1,10z M331.6,959.4H117.2c-42.3,0-76.6-34.3-76.6-76.6V362.2h290.9V959.4z M637.8,959.4H362.2V362.2h275.6V959.4z M959.4,882.8c0,42.3-34.3,76.6-76.6,76.6H668.4V362.2h290.9V882.8z M959.4,331.6H40.6V117.2c0-42.3,34.3-76.6,76.6-76.6h214.4h30.6h275.6h30.6h214.4c42.3,0,76.6,34.3,76.6,76.6V331.6 Z";
        var group = this.__objSVG.createGroup(this.__COLUMNSETTING_ICON_ID + "group");
        var path = this.__objSVG.createPath(this.__COLUMNSETTING_ICON_ID + "path", COLUMNSETTING_ICON_PATH, null);
        group.appendChild(path);
        this.__objSVG.addElementInSymbol(this.__COLUMNSETTING_ICON_ID, COLUMNSETTING_ICON_VIEWPORT, group);
    };
	
	return NSSvgShapes;
})();
nsModuleExport(this,"NSSvgShapes",NSSvgShapes);